const categories = {
    PDP_ERROR: 'pdp_error'
};

const edapLabels = {
    DATES_ERROR: 'dates_error',
    GUESTS_ERROR: 'guests_error',
    UNDEFINED_ERROR: 'undefined_error',
    DATES_ACCURATE: 'dates_accurate',
    DATES_SUCCESS: 'date_success'
};

const edapDetailLabels = {
    DATES_ACCURATE: 'enter dates',
    DATES_SUCCESS: 'dates avail',
    UNAVAILABLE_DATES_NO_LONGER_AVAILABLE: 'dates no longer avail',
    UNAVAILABLE_DATES: 'dates unavail',
    MIN_PRIOR_NOTIFY: 'min prior notify',
    MIN_STAY_NOT_MET: 'min stay',
    SAME_DAY_ARRIVAL: 'same day arrival',
    ENTER_GUESTS: 'num guests',
    QUOTE_ERROR: 'no quote'
};

const edapActions = {
    NEEDS_ADULTS: 'needs-adults',
    OVER_MAX_OCCUPANCY: 'over-max-occupancy',
    PETS_NOT_ALLOWED: 'pets-not-allowed',
    TOO_MANY_CHILDREN: 'too-many-children',
    UNAVAILABLE: 'unavailable',
    UNDEFINED_ERROR: 'undefined_error',
    DATES_ACCURATE: 'accurate-dates',
    DATES_SUCCESS: 'date-success'
};

const translationKeys = {
    DATALESS_OVER_MAX_OCCUPANCY: 'errorMaxOccupancy',
    DATES_ACCURATE: 'accuratePricingPrompt',
    DATES_SUCCESS: 'availableNoticePropTitle',
    MIN_PRIOR_NOTIFY: 'minPriorNotify',
    MIN_STAY_NOT_MET: 'minStayNotMet',
    NEEDS_ADULTS: 'needsAdults',
    OVER_MAX_OCCUPANCY: 'maxGuestsWithValue',
    PLEASE_ENTER_GUESTS: 'pleaseEnterGuests',
    PETS_NOT_ALLOWED: 'petsNotAllowed',
    SAME_DAY_ARRIVAL: 'sameDayArrivalNotAvailable',
    TOO_MANY_ADULTS: 'overlimitAdults',
    TOO_MANY_CHILDREN: 'tooManyChildren',
    UNAVAILABLE_DATES: 'datesUnavailable',
    UNAVAILABLE_DATES_NO_LONGER_AVAILABLE: 'errorDatesNoLongerAvailable',
    UNAVAILABLE_RATES: 'ratesNotAvailable',
    UNAVAILABLE_RATES_LISTING_DOESNT_HAVE_RATES: 'errorCoverage',
    UNDEFINED: 'defaultError'
};

const types = {
    DATES: 'dates',
    GUESTS: 'guests',
    NON_SPECIFIC: 'non-specific'
};

const icons = {
    SUCCESS: 'success',
    WARNING: 'warning',
    DANGER: 'danger'
};

const severityLevels = {
    [icons.SUCCESS]: 'success',
    [icons.WARNING]: 'info',
    [icons.DANGER]: 'error'
};

const errors = {
    DATALESS_OVER_MAX_OCCUPANCY: {
        edapAction: edapActions.OVER_MAX_OCCUPANCY,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.GUESTS_ERROR,
        requiresDataForTranslation: false,
        translationKey: translationKeys.DATALESS_OVER_MAX_OCCUPANCY,
        type: types.GUESTS,
        icon: icons.DANGER
    },
    DOES_NOT_MEET_REQUIREMENT: {
        edapAction: edapActions.UNDEFINED_ERROR,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.UNDEFINED_ERROR,
        requiresDataForTranslation: false,
        translationKey: translationKeys.UNDEFINED,
        type: types.NON_SPECIFIC,
        icon: icons.DANGER
    },
    ENTER_GUESTS: {
        edapAction: edapActions.UNDEFINED_ERROR,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.UNDEFINED_ERROR,
        edapDetailLabel: edapDetailLabels.ENTER_GUESTS,
        requiresDataForTranslation: false,
        translationKey: translationKeys.PLEASE_ENTER_GUESTS,
        type: types.GUESTS,
        icon: icons.WARNING
    },
    MIN_PRIOR_NOTIFY: {
        edapAction: edapActions.UNDEFINED_ERROR,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.DATES_ERROR,
        edapDetailLabel: edapDetailLabels.MIN_PRIOR_NOTIFY,
        requiresDataForTranslation: false,
        translationKey: translationKeys.MIN_PRIOR_NOTIFY,
        type: types.DATES,
        icon: icons.DANGER
    },
    MIN_STAY_NOT_MET: {
        edapAction: edapActions.MIN_STAY_NOT_MET,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.DATES_ERROR,
        edapDetailLabel: edapDetailLabels.MIN_STAY_NOT_MET,
        requiresDataForTranslation: false,
        translationKey: translationKeys.MIN_STAY_NOT_MET,
        type: types.DATES,
        icon: icons.DANGER
    },
    MIN_STAY_REQUIRED: {
        edapAction: edapActions.MIN_STAY_NOT_MET,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.DATES_ERROR,
        requiresDataForTranslation: false,
        type: types.DATES,
        icon: icons.DANGER
    },
    NEEDS_ADULTS: {
        edapAction: edapActions.NEEDS_ADULTS,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.GUESTS_ERROR,
        requiresDataForTranslation: false,
        translationKey: translationKeys.NEEDS_ADULTS,
        type: types.GUESTS,
        icon: icons.WARNING
    },
    OVER_MAX_OCCUPANCY: {
        edapAction: edapActions.OVER_MAX_OCCUPANCY,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.GUESTS_ERROR,
        requiresDataForTranslation: true,
        translationKey: translationKeys.OVER_MAX_OCCUPANCY,
        type: types.GUESTS,
        icon: icons.DANGER
    },
    PETS_NOT_ALLOWED: {
        edapAction: edapActions.PETS_NOT_ALLOWED,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.GUESTS_ERROR,
        requiresDataForTranslation: false,
        translationKey: translationKeys.PETS_NOT_ALLOWED,
        type: types.GUESTS,
        icon: icons.DANGER
    },
    SAME_DAY_ARRIVAL: {
        edapAction: edapActions.UNDEFINED_ERROR,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.DATES_ERROR,
        edapDetailLabel: edapDetailLabels.SAME_DAY_ARRIVAL,
        requiresDataForTranslation: false,
        translationKey: translationKeys.SAME_DAY_ARRIVAL,
        type: types.DATES,
        icon: icons.DANGER
    },
    TOO_MANY_CHILDREN: {
        edapAction: edapActions.TOO_MANY_CHILDREN,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.GUESTS_ERROR,
        requiresDataForTranslation: true,
        translationKey: translationKeys.TOO_MANY_CHILDREN,
        type: types.GUESTS,
        icon: icons.DANGER
    },
    TOO_MANY_ADULTS: {
        edapAction: edapActions.OVER_MAX_OCCUPANCY,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.GUESTS_ERROR,
        requiresDataForTranslation: true,
        translationKey: translationKeys.TOO_MANY_ADULTS,
        type: types.GUESTS,
        icon: icons.DANGER
    },
    UNAVAILABLE_DATES: {
        edapAction: edapActions.UNAVAILABLE,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.DATES_ERROR,
        edapDetailLabel: edapDetailLabels.UNAVAILABLE_DATES,
        requiresDataForTranslation: false,
        translationKey: translationKeys.UNAVAILABLE_DATES,
        type: types.DATES,
        icon: icons.DANGER
    },
    UNAVAILABLE_DATES_NO_LONGER_AVAILABLE: {
        edapAction: edapActions.UNAVAILABLE,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.DATES_ERROR,
        edapDetailLabel: edapDetailLabels.UNAVAILABLE_DATES_NO_LONGER_AVAILABLE,
        requiresDataForTranslation: false,
        translationKey: translationKeys.UNAVAILABLE_DATES_NO_LONGER_AVAILABLE,
        type: types.DATES,
        icon: icons.DANGER
    },
    UNAVAILABLE_RATES: {
        edapAction: edapActions.UNDEFINED_ERROR,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.UNDEFINED_ERROR,
        requiresDataForTranslation: false,
        translationKey: translationKeys.UNAVAILABLE_RATES,
        type: types.NON_SPECIFIC,
        icon: icons.DANGER
    },
    UNAVAILABLE_RATES_LISTING_DOESNT_HAVE_RATES: {
        edapAction: edapActions.UNDEFINED_ERROR,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.UNDEFINED_ERROR,
        requiresDataForTranslation: false,
        translationKey: translationKeys.UNAVAILABLE_RATES_LISTING_DOESNT_HAVE_RATES,
        type: types.NON_SPECIFIC,
        icon: icons.DANGER
    },
    UNDEFINED: {
        edapAction: edapActions.UNDEFINED_ERROR,
        edapCategory: categories.PDP_ERROR,
        edapLabel: edapLabels.UNDEFINED_ERROR,
        edapDetailLabel: edapDetailLabels.QUOTE_ERROR,
        requiresDataForTranslation: false,
        translationKey: translationKeys.UNDEFINED,
        type: types.NON_SPECIFIC,
        icon: icons.DANGER
    }
};

const info = {
    DATES_ACCURATE: {
        edapAction: edapActions.DATES_ACCURATE,
        edapLabel: edapLabels.DATES_ACCURATE,
        edapDetailLabel: edapDetailLabels.DATES_ACCURATE,
        requiresDataForTranslation: false,
        translationKey: translationKeys.DATES_ACCURATE,
        icon: icons.WARNING
    }
};

const success = {
    DATES_SUCCESS: {
        edapAction: edapActions.DATES_SUCCESS,
        edapLabel: edapLabels.DATES_SUCCESS,
        edapDetailLabel: edapDetailLabels.DATES_SUCCESS,
        requiresDataForTranslation: false,
        translationKey: translationKeys.DATES_SUCCESS,
        icon: icons.SUCCESS
    }
};

// Full list of error codes:
// https://github.homeawaycorp.com/eCommerce/api-operations-ecommerce/blob/8f399d84ff85922dec396b9e62d6589a5ae277f4/api-operations-ecommerce-logic/src/main/java/com/homeaway/api/operations/ecommerce/traveler/checkout/errors/ErrorCode.java
const priceErrorMap = {
    'BAP001': errors.UNDEFINED,
    'BAP007': errors.UNDEFINED,
    'ECP001': errors.UNDEFINED,
    'ECP004': errors.UNAVAILABLE_RATES,
    'ECP007': errors.UNAVAILABLE_RATES_LISTING_DOESNT_HAVE_RATES,
    'ECP009': errors.OVER_MAX_OCCUPANCY,
    'ECP010': errors.UNAVAILABLE_DATES,
    'ECP013': errors.UNAVAILABLE_DATES_NO_LONGER_AVAILABLE,
    'PMX016': errors.UNAVAILABLE_DATES,
    'PMX010': errors.DATALESS_OVER_MAX_OCCUPANCY,
    'PMX013': errors.MIN_STAY_REQUIRED,
    'PMX014': errors.DOES_NOT_MEET_REQUIREMENT,
    'PMX019': errors.UNDEFINED,
    'PMX018': errors.TOO_MANY_CHILDREN,
    'PMX020': errors.UNDEFINED,
    'PMX021': errors.UNDEFINED,
    'PMX036': errors.UNDEFINED,
    'TCB004': errors.UNAVAILABLE_DATES_NO_LONGER_AVAILABLE,
    'TCB040': errors.DOES_NOT_MEET_REQUIREMENT,
    'TCB041': errors.UNAVAILABLE_DATES,
    'TCB042': errors.MIN_STAY_NOT_MET,
    'UNDEFINED': errors.UNDEFINED
};

function triggerErrorEdapEvent(triggerEdapEvent, errorObject) {
    triggerEdapEvent('generic.event', {
        eventcategory: errorObject.edapCategory,
        eventaction: errorObject.edapAction,
        eventlabel: errorObject.edapLabel
    });
}

function isGuestError(error) {
    return !!error && error.type === types.GUESTS;
}

function isEmptyGuestsError(error) {
    return !!error && error.translationKey === translationKeys.PLEASE_ENTER_GUESTS;
}

function isDateError(error) {
    return !!error && error.type === types.DATES;
}

function isEmptyDatesError(error) {
    return !!error && error.translationKey === translationKeys.DATES_ACCURATE;
}

export default triggerErrorEdapEvent;
export {
    errors,
    icons,
    info,
    isEmptyGuestsError,
    isGuestError,
    isDateError,
    isEmptyDatesError,
    success,
    priceErrorMap,
    severityLevels,
    triggerErrorEdapEvent,
    types
};
